const DEFAULT_PLACEHOLDER = '[T]';

const insertValue = (text: string | undefined, value: string | number, placeholder = DEFAULT_PLACEHOLDER) =>
	text?.replace(placeholder, typeof value === 'number' ? String(Math.round(value)) : value) || '';

export default insertValue;
